export const CANCELLATION_SURVEY_ID = "ee1803e1-ae28-43c8-84d3-5547f4a146e9";
